// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3v0Ia","name":"ConsentHeader_name__MdiyK","birthday":"ConsentHeader_birthday__3KP3u","skeleton":"ConsentHeader_skeleton__31E2-"};